import React from 'react'

export default function NotFound() {
    const { ERROR_TEXT } = window['config']
    return (
        <div className="error">
            { ERROR_TEXT }
        </div>
    )
}